"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicableRateSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.applicableRateSchema = {
    type: 'object',
    properties: {
        goodsAndServiceTaxRealEstateRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        harmonizedSalesTaxRealEstateRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        legalActionTimeOfDayCount: {
            type: ['integer', 'null'],
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'should be an integer or null',
        },
        maximumAppraisalEditAmount: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: -99999,
            decimal: [7, 2],
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        maximumEditAssignmentAmount: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: -99999,
            decimal: [7, 2],
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        maximumEditDeficitAmount: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: -99999,
            decimal: [7, 2],
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        maximumEditTitleAmount: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: -99999,
            decimal: [7, 2],
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        propertyManagementFeeAmount: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: -99999,
            decimal: [7, 2],
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        provinceID: {
            type: ['string', 'null'],
            enum: Object.values(constants_1.StatisticsCanadaProvinceID),
            errorMessage: 'should equate to a valid provinceID enum value or null',
        },
        provincialSalesTaxRealEstateRatePercent: {
            type: ['number', 'null'],
            maximum: 99,
            minimum: -99,
            decimal: [9, 7],
            errorMessage: 'should be a decimal with up to 9 digits in total and 7 digits of precision or null',
        },
        realEstateCommissionRatePercent: {
            type: ['number', 'null'],
            maximum: 99,
            minimum: -99,
            decimal: [9, 7],
            errorMessage: 'should be a decimal with up to 9 digits in total and 7 digits of precision or null',
        },
    },
};
